import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { environment } from '../environments/environment';
import { AdminConstant } from '../constant/adminConstant';
import { Observable } from 'rxjs/internal/Observable';
import { APIConstant } from '../constant/APIConstant';

@Injectable({
  providedIn: 'root'
})
export class AdminService {

  constructor(private readonly apiService: ApiService) { }

  apiURL = environment.serviceUrl

  /*---- Organization Screen ----*/

  // Create organization
  getCreateOrgURL = this.apiURL + AdminConstant.organization.create;
  createOrg(data: any) {
    return this.apiService.post(this.getCreateOrgURL, data);
  }

  // Get organization
  getGetOrgURL = this.apiURL + AdminConstant.organization.get;
  getOrg() {
    return this.apiService.get(this.getGetOrgURL);
  }

  // Update organization records
  getUpdateOrgURL = this.apiURL + AdminConstant.organization.update;
  updateOrganization(data: any) {
    return this.apiService.post(this.getUpdateOrgURL, data);
  }

  // Disable organization
  getDisableOrgURL = this.apiURL + AdminConstant.organization.disable;
  disableOrganization(id: any) {
    return this.apiService.post(this.getDisableOrgURL + '?id=' + id, id);
  }


  /*---- Client management Screen ----*/

  // Insert client management
  getInsertClientManagementURL = this.apiURL + AdminConstant.clientManagement.getInsertConstant;
  insertClientManagement(formData: any) {
    return this.apiService.post(this.getInsertClientManagementURL, formData);
  }

  // Get client management
  getGetClientManagementURL = this.apiURL + AdminConstant.clientManagement.getClientListConstant;
  getClientManagement() {
    return this.apiService.get(this.getGetClientManagementURL);
  }

  // Update client management
  getUpdateClientManagementURL = this.apiURL + AdminConstant.clientManagement.getClientUpdateConstant;
  updateClientManagement(data: any, id: any) {
    return this.apiService.post(this.getUpdateClientManagementURL, data);
  }

  // Insert admin log
  getAdminlogInsertURL = this.apiURL + AdminConstant.clientManagement.getAdminLogConstant;
  adminlogInsert(formData: any) {
    return this.apiService.post(this.getAdminlogInsertURL, formData);
  }


  /*---- User Management Screen ----*/

  // Get Client BU Select
  getClientBuSelectURL = this.apiURL + AdminConstant.userManagement.getClientBuSelect;
  getClientBuSelect() {
    return this.apiService.get(this.getClientBuSelectURL);
  }

  // Get Clients by pattern
  getClientsmanagURL = this.apiURL + AdminConstant.userManagement.getUserBypattern;
  getClientsmanag(uid: any) {
    return this.apiService.post(this.getClientsmanagURL, uid);
  }

  // Insert user management data
  insertUserMgmtDataURL = this.apiURL + AdminConstant.userManagement.getInsertManagement;
  insertUserMgmtData(postData: any) {
    return this.apiService.post(this.insertUserMgmtDataURL, postData);
  }

  // Update Sec User
  secUserUpdateURL = this.apiURL + AdminConstant.userManagement.getSecUserUpdate;
  SecUserUpdate(data: any) {
    return this.apiService.post(this.secUserUpdateURL, data);
  }

  // Delete user
  deleteUserURL = this.apiURL + AdminConstant.userManagement.getDeleteUser;
  deleteUser(email: any) {
    return this.apiService.get(this.deleteUserURL + email);
  }

  // Get user access by user
  getUserAccessByUserURL = this.apiURL + AdminConstant.userManagement.getAccessByUser;
  getUserAccessByUser(getData: any) {
    return this.apiService.get(this.getUserAccessByUserURL + getData);
  }

  /*---- User Roles Screen ----*/

  // Get user access by user
  getUserRolesURL = this.apiURL + AdminConstant.userRoles.getRoles;
  getUserRoles(data: any) {
    return this.apiService.get(this.getUserRolesURL + data, data);
  }

  /*---- Image Management Screen ----*/

  // Get user access by user
  getRepoListURL = this.apiURL + AdminConstant.imageManagement.getFetchRepoList;
  fetchRepoList() {
    return this.apiService.get(this.getRepoListURL);
  }
  // Get user access by user
  getTriggerPipelineURL = this.apiURL + AdminConstant.imageManagement.getTriggerPipeline;
  triggerPipeline(data: any) {
    return this.apiService.post(this.getTriggerPipelineURL, data);
  }

  // Get all component versions
  InsertComponentVersionURL = this.apiURL + AdminConstant.imageManagement.InsertComponentVersion;
  InsertComponentVersion(data: any) {
    return this.apiService.post(this.InsertComponentVersionURL, data);
  }

  // Get user access by user
  getOrganizationListURL = this.apiURL + AdminConstant.imageManagement.getOrganizationList;
  fetchOrganization() {
    return this.apiService.get(this.getOrganizationListURL);
  }

  // Get user access by user
  getFetchImagesURL = this.apiURL + AdminConstant.imageManagement.getImages;
  fetchimages(data: any) {
    return this.apiService.get(this.getFetchImagesURL + data.clientid + "&projectid=" + data.projectId);
  }

  // Get user access by user
  getProjectsURL = this.apiURL + AdminConstant.imageManagement.getProjects;
  fetchProjects(data: any) {
    return this.apiService.get(this.getProjectsURL + data);
  }

  // Get user access by user 
  getPipelineListURL = this.apiURL + AdminConstant.imageManagement.getPipelineList;
  fetchPipelineList(data: any) {
    return this.apiService.post(this.getPipelineListURL, data);
  }

  // Get user access by user
  getArcImagesURL = this.apiURL + AdminConstant.imageManagement.getArcImages;
  fetchArcImages(data: any) {
    return this.apiService.post(this.getArcImagesURL, data);
  }

  // Get user access by user
  getBranchListURL = this.apiURL + AdminConstant.imageManagement.getBrancheList;
  fetchBranchList(data: any) {
    return this.apiService.post(this.getBranchListURL, data);
  }

  // Get user access by user
  getReposListURL = this.apiURL + AdminConstant.imageManagement.getRepoList;
  getRepositories(data: any) {
    return this.apiService.post(this.getReposListURL, data);
  }

  // Get user access by user
  getAddPipelineURL = this.apiURL + AdminConstant.imageManagement.getAddPipeline;
  addPipeline(data: any) {
    return this.apiService.post(this.getAddPipelineURL, data);
  }

  // Get all ACR repositories
  getAllACRRepoURL = this.apiURL + AdminConstant.imageManagement.getAllACRRepo;
  getAllACRRepo(data: any) {
    return this.apiService.post(this.getAllACRRepoURL, data);
  }

  /*---- License Keys Screen ----*/

  // Insert project key
  getInsertProjectKeyURL = this.apiURL + AdminConstant.licenseKeys.getInsertProjectKey;
  insertProjectKey(data: any) {
    return this.apiService.post(this.getInsertProjectKeyURL, data);
  }

  // Remove project key
  getRemoveProjectKeyURL = this.apiURL + AdminConstant.licenseKeys.getRemoveProjectKey;
  removeProjectKey(keyId: any) {
    return this.apiService.get(this.getRemoveProjectKeyURL + keyId);
  }

  // Get key details
  getKeyDetailsURL = this.apiURL + AdminConstant.licenseKeys.getKeydetails;
  getKeyDetails(projectId: any) {
    return this.apiService.get(this.getKeyDetailsURL + projectId);
  }

  // Send key information
  getSendKeyURL = this.apiURL + AdminConstant.licenseKeys.getSendKey;
  sendKeyInfo(data: any) {
    return this.apiService.post(this.getSendKeyURL, data);
  }

  getProjectSelectURL = this.apiURL + AdminConstant.licenseKeys.getProjectSelectConstant
  getProjectSelect() {
    return this.apiService.get(this.getProjectSelectURL);
  }

  /*---- ACR Access Screen ----*/

  // Request service principle
  getRequestServicePrincipleURL = this.apiURL + AdminConstant.acrAccess.getServicePrinciple;
  requestServicePrinciple(data: any) {
    return this.apiService.get(this.getRequestServicePrincipleURL + data.projectname + '&projectId=' + data.projectId);
  }

  /*---- DNS Mapping ----*/

  // Get project URLs
  getProjectURLsURL = this.apiURL + AdminConstant.dnsMapping.getProjectURLS;
  projectURLs(data: any) {
    return this.apiService.get(this.getProjectURLsURL + data.projectId + "&urlid=" + data.urlid);
  }

  // Map IP to DNS
  getDNSMappingURL = this.apiURL + AdminConstant.dnsMapping.getDNSMappingID;
  mappingIP(data: any) {
    return this.apiService.post(this.getDNSMappingURL, data);
  }

  // Create organization
  getCreateOrgaURL = this.apiURL + AdminConstant.addOrganization.getCreateOrg;
  createOrganization(data: any) {
    return this.apiService.post(this.getCreateOrgaURL, data);
  }

  // Update organization records
  getUpdateOrgaURL = this.apiURL + AdminConstant.addOrganization.getUpdateOrg;
  updateOrganizationRecords(data: any) {
    return this.apiService.post(this.getUpdateOrgaURL, data);
  }

  // Disable organization
  getDisableOrgaURL = this.apiURL + AdminConstant.addOrganization.getDisableOrg;
  disableOrg(id: any) {
    return this.apiService.post(this.getDisableOrgaURL + id, id);
  }

  /*---- Repo Approval ----*/

  // Get admins
  getAdminsURL = this.apiURL + AdminConstant.repoApproval.getAdmins;
  getAdmins() {
    return this.apiService.get(this.getAdminsURL);
  }

  getRepoRequestsURL = this.apiURL + AdminConstant.repoApproval.getRepoRequests;
  getRepoRequests(data: any) {
    return this.apiService.post(this.getRepoRequestsURL, data);
  }
  changeAccessToStakeHolderURL = this.apiURL + AdminConstant.repoApproval.getChangeAccessToStakeHolder;
  changeAccessToStakeHolder(data: any) {
    return this.apiService.post(this.changeAccessToStakeHolderURL, data);
  }

  updateRepoRequestURL = this.apiURL + AdminConstant.repoApproval.getUpdateRequest;
  updateRepoRequest(data: any) {
    return this.apiService.post(this.updateRepoRequestURL, data);
  }

  changeAccessToBasicURL = this.apiURL + AdminConstant.repoApproval.getChangeAccessToBasic;
  changeAccessToBasic(data: any) {
    return this.apiService.post(this.changeAccessToBasicURL, data);
  }

  getBasicUsersURL = this.apiURL + AdminConstant.repoApproval.getBasicAccessList;
  getBasicUsers(org: any) {
    return this.apiService.get(this.getBasicUsersURL + org);
  }

  getUsersURL = this.apiURL + AdminConstant.repoApproval.getRepoUsers;
  getUsers(org: any) {
    return this.apiService.get(this.getUsersURL + org);
  }

  getAllCommitsURL = this.apiURL + AdminConstant.gitCopy.getAllCommits;
  getAllCommits(data: any) {
    return this.apiService.post(this.getAllCommitsURL, data);
  }

  updateCopyStatusURL = this.apiURL + AdminConstant.gitCopy.getUpdateStatus;
  updateCopyStatus(data: any) {
    return this.apiService.post(this.updateCopyStatusURL, data);
  }

  copyFilesIndividuallyURL = this.apiURL + AdminConstant.gitCopy.getCopyIndividual;
  copyFilesIndividually(data: any) {
    return this.apiService.post(this.copyFilesIndividuallyURL, data);
  }

  getReposURL = this.apiURL + AdminConstant.gitCopy.getRepos;
  getRepositorie(data: any) {
    return this.apiService.post(this.getReposListURL, data);
  }

  getRepoRequestURL = this.apiURL + AdminConstant.repoRequest.getUserRepoRequest;
  repoRequest(data: any) {
    return this.apiService.post(this.getRepoRequestURL, data);
  }

  getDeploymentsBatchURL = this.apiURL + AdminConstant.Kubernetes.getDeploymentsBatch;
  getDeploymentsBatch = (body: any): Observable<any> => {
    return this.apiService.post(
      this.getDeploymentsBatchURL
      , body);
  };
  scaleDeploymentURL = this.apiURL + AdminConstant.Kubernetes.scaleDeployment;
  scaleDeployment = (body: any, param: any): Observable<any> => {
    return this.apiService.post(
      this.scaleDeploymentURL + "?onoff=" + param
      , body);
  };
  GetLicenseDetailsURL = this.apiURL + AdminConstant.Kubernetes.getLicenseDetails;
  GetLicenseDetails = (body: any): Observable<any> => {
    return this.apiService.get(this.GetLicenseDetailsURL + body);
  }

  IsLicenseExpiredURL = this.apiURL + AdminConstant.Kubernetes.isLicenseExpired;
  IsLicenseExpired = (body: any): Observable<any> => {
    return this.apiService.get(this.IsLicenseExpiredURL + body);
  }
  getProjectTokenURL = this.apiURL + AdminConstant.Kubernetes.GetProjectToken;
  getProjectsToken = (body: any): Observable<string> => {
    return this.apiService.get(
      this.getProjectTokenURL
      + body.projectId + "&migid=" + body.migid);
  };
  ProjectUrlsUpdateURL = this.apiURL + AdminConstant.Kubernetes.ProjectUrlsUpdate;
  ProjectUrlsUpdate = (body: any): Observable<any> => {
    return this.apiService.post(
      this.ProjectUrlsUpdateURL
      , body);
  };

  versionInsertURL = this.apiURL + AdminConstant.imageManagement.versionInsert;
  versionInsert(data: any) {
    return this.apiService.post(this.versionInsertURL, data);
  }

  fetchComponentVersionsURL = this.apiURL + AdminConstant.imageManagement.fetchComponentVersions;
  fetchComponentVersions() {
    return this.apiService.get(this.fetchComponentVersionsURL);
  }
  //FetchQmigVersionByProject
  FetchQmigVersionByProjectURL = this.apiURL + AdminConstant.imageManagement.FetchQmigVersionByProject;
  FetchQmigVersionByProject = (body: any): Observable<any> => {
    return this.apiService.post(
      this.FetchQmigVersionByProjectURL
      , body);
  };
  FetchImageVersionInfoURL = this.apiURL + AdminConstant.imageManagement.FetchImageVersionInfo;
  FetchImageVersionInfo = (body: any): Observable<any> => {
    return this.apiService.post(
      this.FetchImageVersionInfoURL
      , body);
  };

  FetchlatestimageInfoURL = this.apiURL + AdminConstant.imageManagement.FetchlatestImageInfo;
  FetchlatestImageInfo = (body: any): Observable<any> => {
    return this.apiService.post(
      this.FetchlatestimageInfoURL
      , body);
  };
  clientQuadUpdateURL = this.apiURL + AdminConstant.imageManagement.clientQuadUpdate;
  clientQuadUpdate = (body: any): Observable<any> => {
    return this.apiService.post(this.clientQuadUpdateURL, body);
  };
  //setimages to kube
  kubeSetImagesURL = this.apiURL + AdminConstant.imageManagement.kubeSetImages;
  kubeSetImages = (body: any): Observable<any> => {
    return this.apiService.post(
      this.kubeSetImagesURL
      , body);
  }
  getDeployedImages(namespace: string): Observable<any> {
    return this.apiService.get(environment.qcamAiURL + 'dashboard/kubernetes/namespaces/' + encodeURIComponent(namespace) + '/deployment-images');
  }
  //vacuum
  dbnameurl = this.apiURL + AdminConstant.vacuum.getdbnames
  getdbnames = (body: any): Observable<any> => {
    return this.apiService.get(this.dbnameurl + body);
  };
  getconnectionurl = this.apiURL + AdminConstant.vacuum.getConnections
  getConList = (body: any): Observable<any> => {
    return this.apiService.get(this.getconnectionurl + body);
  };
  FetchVacuumDataurl = this.apiURL + AdminConstant.vacuum.FetchVacuumData
  FetchVacuumData = (body: any): Observable<any> => {
    return this.apiService.get(this.FetchVacuumDataurl + body.ConId + "&dbname=" + body.dbname + "&schemas=" + body.schemas);
  };
  GetAnalyzeDataurl = this.apiURL + AdminConstant.vacuum.GetAnalyzeData
  GetAnalyzeData = (body: any): Observable<any> => {
    return this.apiService.get(this.GetAnalyzeDataurl + body.ConId + "&dbname=" + body.dbname + "&schemas=" + body.schemas);
  };
  triggerVacuumURL = this.apiURL + AdminConstant.vacuum.triggerVacuum
  triggerVacuum = (body: any): Observable<any> => {
    return this.apiService.post(this.triggerVacuumURL, body);
  };
  GetReqDataURL = this.apiURL + AdminConstant.vacuum.GetReqData
  GetReqData = (body: any): Observable<any> => {
    return this.apiService.get(this.GetReqDataURL + body.projectId + '&operationType=' + body.operationType);
  };
  deleteTableDataURL = this.apiURL + AdminConstant.vacuum.deleteTableData;
  deleteTableData = (body: any): Observable<any> => {
    return this.apiService.get(this.deleteTableDataURL + body.projectId + '&requestId=' + body.requestId);
  };
  tgtSchemaSelectwithdburl = this.apiURL + AdminConstant.vacuum.tgtSchemaSelectwithdb
  tgtSchemaSelectwithdb(data: any) {
    return this.apiService.get(this.tgtSchemaSelectwithdburl + data.conid + "&dbname=" + data.dbname);
  };
  //connection
  addConnectionURL = this.apiURL + AdminConstant.connection.addProjectObject;
  addConnection = (body: any): Observable<any> => {
    return this.apiService.post(this.addConnectionURL, body);
  }
  //srcTgtConfSelectInsert
  srcTgtConfSelectInsertURL = this.apiURL + AdminConstant.connection.srcTgtConfSelectInsert;
  srcTgtConfSelectInsert = (body: any): Observable<any> => {
    return this.apiService.post(this.srcTgtConfSelectInsertURL, body);
  }
  GetDBConnectionsURL = this.apiURL + AdminConstant.connection.GetDBConnections;
  GetDBConnections = (body: any): Observable<any> => {
    return this.apiService.post(this.GetDBConnectionsURL, body)
  }
  //UpdateConnection
  UpdateConnectionURL = this.apiURL + AdminConstant.connection.UpdateConnection;
  UpdateConnection = (body: any): Observable<any> => {
    return this.apiService.post(this.UpdateConnectionURL, body);
  }
  //TriggerDBA
  TriggerDBAURL = this.apiURL + AdminConstant.vacuum.TriggerDBA;
  TriggerDBA = (body: any): Observable<any> => {
    return this.apiService.post(this.TriggerDBAURL, body);
  }
  deleteDbConnectionURL = this.apiURL + AdminConstant.connection.deleteDbConnection;
  deleteDbConnection = (body: any): Observable<any> => {
    return this.apiService.get(this.deleteDbConnectionURL + body.projectId + '&id=' + body.id)
  }
  ClientProjectInsertURL = this.apiURL + AdminConstant.connection.ClientProjectInsert;
  ClientProjectInsert = (body: any): Observable<any> => {
    return this.apiService.post(this.ClientProjectInsertURL, body)
  }

  UserInsertURL = this.apiURL + AdminConstant.connection.UserInsert;
  UserInsert = (body: any): Observable<any> => {
    return this.apiService.post(this.UserInsertURL, body)
  }
  //FetchComponentData
  FetchComponentDataURL = this.apiURL + AdminConstant.release.FetchComponentData;
  FetchComponentData = (body: any): Observable<any> => {
    return this.apiService.post(this.FetchComponentDataURL, body)
  }
  //FetchQmigVersion
  FetchQmigVersionURL = this.apiURL + AdminConstant.release.FetchQmigVersion;
  FetchQmigVersion = (body: any): Observable<any> => {
    return this.apiService.get(this.FetchQmigVersionURL + body.clientId + '&projectId=' + body.projectId)
  }

  GetFilesFromDirURL = this.apiURL + AdminConstant.vacuum.GetFilesFromDir;
  GetFilesFromDir = (body: any): Observable<any> => {
    return this.apiService.get(this.GetFilesFromDirURL + body)
  }

  //agent
  buildUrl = (base: string, path: string): string =>
    `${this.apiService}${base}${path}`;
  // `${environment.serviceUrl2}${base}${path}`;
  postToApi = (url: string, body: any): Observable<any> =>
    this.apiService.post(url, body);
  DBA = 'dba/';
  PerformanceURL = 'performance/';
  getAgent = (body: any, type: 'DBA' | 'Performance'): Observable<any> => {
    const basePath = type === 'DBA' ? this.DBA : this.PerformanceURL;
    const url = this.buildUrl(basePath, type === 'DBA' ? AdminConstant.dba.getAgent : AdminConstant.dba.getPerAgent);
    return this.postToApi(url, body);
  };

  clearHistory = (body: any, type: 'DBA' | 'Performance'): Observable<any> => {
    const basePath = type === 'DBA' ? this.DBA : this.PerformanceURL;
    const url = this.buildUrl(basePath, AdminConstant.dba.clearChatHistory);
    return this.postToApi(url, body);
  };

  //dba_monitoring
  DBAScriptInsertionURL = this.apiURL + AdminConstant.monitoring.DBAScriptInsertion
  DBAScriptInsertion = (body: any): Observable<any> => {
    return this.apiService.post(this.DBAScriptInsertionURL, body);
  };
  DBACategoryNameURL = this.apiURL + AdminConstant.monitoring.DBACategoryName
  DBACategoryName = (body: any): Observable<any> => {
    return this.apiService.get(this.DBACategoryNameURL + body.category);
  };
  DBATaskListURL = this.apiURL + AdminConstant.monitoring.DBATaskList;
  DBATaskList = (body: any): Observable<any> => {
    return this.apiService.get(this.DBATaskListURL + body.projectId)
  }

  QueryExecutionURL = this.apiURL + AdminConstant.monitoring.QueryExecution
  DBAScriptQueryExecution = (body: any): Observable<any> => {
    return this.apiService.post(this.QueryExecutionURL, body);
  };
  DBARunidsURL = this.apiURL + AdminConstant.monitoring.GetDBARunids;
  GetDBARunids = (body: any): Observable<any> => {
    return this.apiService.post(this.DBARunidsURL, body)
  }
  DBAExecResultsURL = this.apiURL + AdminConstant.monitoring.GetDBAExeResults;
  GetDBAExecResultsByRunid = (body: any): Observable<any> => {
    return this.apiService.get(this.DBAExecResultsURL + body)
  }
  GetbloatingDetailsurl = this.apiURL + AdminConstant.monitoring.GetbloatingDetails
  GetbloatingDetails = (body: any): Observable<any> => {
    return this.apiService.post(this.GetbloatingDetailsurl, body);
  };
  downloadLargeFilesURL = this.apiURL + AdminConstant.monitoring.downloadLargeFiles;
  downloadLargeFiles = (body: string): Observable<any> => {
    return this.apiService.get(this.downloadLargeFilesURL + encodeURIComponent(body), { responseType: 'blob' as 'json' })
  }
  usernameurl = this.apiURL + AdminConstant.monitoring.getusers
  getusernames = (body: any): Observable<any> => {
    return this.apiService.get(this.usernameurl + body.ConId + "&dbname=" + body.dbname);
  };
  rolenameurl = this.apiURL + AdminConstant.monitoring.getroles
  getrolenames = (body: any): Observable<any> => {
    return this.apiService.get(this.rolenameurl + body.ConId + "&dbname=" + body.dbname);
  };
  getobjecttypeurl = this.apiURL + AdminConstant.monitoring.getobjecttype
  getobjecttype = (body: any): Observable<any> => {
    return this.apiService.post(this.getobjecttypeurl, body);
  };
  grantpermissionsurl = this.apiURL + AdminConstant.monitoring.grantpermissions
  grantpermissions = (body: any): Observable<any> => {
    return this.apiService.post(this.grantpermissionsurl, body);

  };
  getpermissionsurl = this.apiURL + AdminConstant.monitoring.getpermissions
  getpermissions = (body: any): Observable<any> => {
    return this.apiService.post(this.getpermissionsurl, body);
  };
  getexecutedataurl = this.apiURL + AdminConstant.monitoring.getexecutedata
  getexecutedata = (body: any): Observable<any> => {
    return this.apiService.get(
      this.getexecutedataurl + body.ConId + "&dbnames=" + body.dbname);
  };
  getobjectnamesurl = this.apiURL + AdminConstant.monitoring.getobjectnames
  getobjectnames = (body: any): Observable<any> => {
    return this.apiService.post(this.getobjectnamesurl, body);
  };
  uploadLargeDocumentURL = this.apiURL + AdminConstant.monitoring.uploadLargeFiles
  uploadLargeDocument = (body: any): Observable<any> => {
    return this.apiService.post(this.uploadLargeDocumentURL, body);
  };
  deleteFileURL = this.apiURL + AdminConstant.monitoring.deleteFile;
  deleteFile = (body: string): Observable<any> => {
    return this.apiService.get(this.deleteFileURL + body)
  }

  // Get Images 
  getImagesURL = this.apiURL + AdminConstant.release.GetImages;
  getImages = (body: any): Observable<any> => {
    return this.apiService.post(this.getImagesURL, body);
  }

  // Release Management insert Component
  insertComponentURL = this.apiURL + AdminConstant.release.insertComponent;
  insertComponent = (body: any): Observable<any> => {
    return this.apiService.post(this.insertComponentURL, body);
  }

  // Update Component 
  updateComponentURL = this.apiURL + AdminConstant.release.updateComponent;
  updateComponent = (body: any): Observable<any> => {
    return this.apiService.get(this.updateComponentURL + body.id + "&type=" + body.type);
  }

  // insertComponentDeployment
  insertComponentDeploymentURL = this.apiURL + AdminConstant.release.insertComponentDeployment;
  insertComponentDeployment = (body: any): Observable<any> => {
    return this.apiService.post(this.insertComponentDeploymentURL, body);
  }

  // updateComponentDeployment
  updateComponentDeploymentURL = this.apiURL + AdminConstant.release.updateComponentDeployment;
  updateComponentDeployment = (body: any): Observable<any> => {
    return this.apiService.post(this.updateComponentDeploymentURL, body);
  }

  // getComponents
  getComponentsURL = this.apiURL + AdminConstant.release.getComponents;
  getComponents = (body: any): Observable<any> => {
    return this.apiService.get(this.getComponentsURL + body.startdate + "&enddate=" + body.enddate);
  }

  //getComponentVersions
  getComponentVersionsURL = this.apiURL + AdminConstant.release.getComponentVersions;
  getComponentVersions = (body: any): Observable<any> => {
    return this.apiService.post(this.getComponentVersionsURL, body);
  }

  //UpdateDeployment Status
  updateDeploymentStatusURL = this.apiURL + AdminConstant.release.updateComponentDeployment;
  updateDeploymentStatus = (flag: string, body: any): Observable<any> => {
    return this.apiService.post(this.updateDeploymentStatusURL + "?flag=" + flag, body);
  }

  // getReleaseOwners
  getReleaseOwnersURL = this.apiURL + AdminConstant.release.getReleaseOwners;
  getReleaseOwners = (): Observable<any> => {
    return this.apiService.get(this.getReleaseOwnersURL);
  }

  // Release Create 
  releaseCreateURL = this.apiURL + AdminConstant.release.releaseCreate;
  releaseCreate = (body: any): Observable<any> => {
    return this.apiService.post(this.releaseCreateURL, body);
  }

  // InsertComponentLevelData
  insertComponentLevelDataURL = this.apiURL + AdminConstant.release.insertComponentLevelData;
  insertComponentLevelData = (body: any): Observable<any> => {
    return this.apiService.post(this.insertComponentLevelDataURL, body);
  }

  // Create a Pull Request
  createPullRequestURL = this.apiURL + AdminConstant.release.createPullRequest;
  createPullRequest = (body: any): Observable<any> => {
    return this.apiService.post(this.createPullRequestURL, body);
  }

  // Get a Pull Request
  getPullRequestURL = this.apiURL + AdminConstant.release.GetPullRequest;
  getPullRequest = (body: any): Observable<any> => {
    return this.apiService.post(this.getPullRequestURL, body);
  }
  // Create a Pull Request
  getComponentsByModulesURL = this.apiURL + AdminConstant.release.getComponentsByModules;
  getComponentsByModules = (body: any): Observable<any> => {
    return this.apiService.get(this.getComponentsByModulesURL + body.module_name);
  }

  // Get Task List By Owner
  getTaskByOwnerURL = this.apiURL + AdminConstant.release.getTaskByOwner;
  getTaskByOwner = (body: any): Observable<any> => {
    return this.apiService.post(this.getTaskByOwnerURL, body);
  }

  // getStatusTasksByTaskID
  getStatusTasksByTaskIDURL = this.apiURL + AdminConstant.release.getStatusTasksByTaskID;
  getStatusTasksByTaskID = (body: any): Observable<any> => {
    return this.apiService.get(this.getStatusTasksByTaskIDURL + body);
  }

  // addStatusTask
  addStatusTaskURL = this.apiURL + AdminConstant.release.addStatusTask;
  addStatusTask = (body: any): Observable<any> => {
    return this.apiService.post(this.addStatusTaskURL, body);
  }

  // insertIntegrationBranch
  insertIntegrationBranchURL = this.apiURL + AdminConstant.release.insertIntegrationBranch;
  insertIntegrationBranch = (body: any): Observable<any> => {
    return this.apiService.post(this.insertIntegrationBranchURL, body);
  }

  // CreateFeatureBranch
  createFeatureBranchURL = this.apiURL + AdminConstant.release.createFeatureBranch;
  createFeatureBranch = (body: any): Observable<any> => {
    return this.apiService.post(this.createFeatureBranchURL, body);
  }

  // updateComponentDeploymentData
  updateComponentDeploymentDataURL = this.apiURL + AdminConstant.release.updateComponentDeploymentData;
  updateComponentDeploymentData = (body: any): Observable<any> => {
    return this.apiService.post(this.updateComponentDeploymentDataURL, body);
  }

  // Save Default Branch
  saveDefaultBranchURL = this.apiURL + AdminConstant.addOrganization.saveDefaultBranch;
  saveDefaultBranch(data: any) {
    return this.apiService.post(this.saveDefaultBranchURL, data);
  }

  // Save Associate Branch
  saveAssociateBranchURL = this.apiURL + AdminConstant.addOrganization.saveAssociateBranch;
  saveAssociateBranch(data: any) {
    return this.apiService.post(this.saveAssociateBranchURL, data);
  }

  // fetch AB Organization
  fetchABOrganizationURL = this.apiURL + AdminConstant.addOrganization.fetchABOrganization;
  fetchABOrganization(data: any) {
    return this.apiService.get(this.fetchABOrganizationURL + data);
  }

  fetchProjectBranchURL = this.apiURL + AdminConstant.addOrganization.GetProjectBranchDetails;
  fetchProjectBranch() {
    return this.apiService.get(this.fetchProjectBranchURL);
  }
  UpdateProjectBranchDetailsURL = this.apiURL + AdminConstant.addOrganization.UpdateProjectBranchDetails;
  UpdateProjectBranchDetails = (data: any): Observable<any> => {
    return this.apiService.get(this.UpdateProjectBranchDetailsURL + data.id + "&integration_branch=" + data.integration_branch);
  }
  //GetModulesByProjectType
  GetModulesByProjectTypeURL = this.apiURL + AdminConstant.release.GetModulesByProjectType;
  GetModulesByProjectType = (data: any): Observable<any> => {
    return this.apiService.get(this.GetModulesByProjectTypeURL + data.prj_type_id);
  }
  //GetPullRequestByComponentType
  GetPullRequestByComponentTypeURL = this.apiURL + AdminConstant.release.GetPullRequestByComponentType;
  GetPullRequestByComponentType = (data: any): Observable<any> => {
    return this.apiService.get(this.GetPullRequestByComponentTypeURL + data.component_type);
  }
  //GetComponentDateByOwner
  GetComponentDateByOwnerURL = this.apiURL + AdminConstant.release.GetComponentDateByOwner;
  GetComponentDateByOwner = (body: any): Observable<any> => {
    return this.apiService.post(this.GetComponentDateByOwnerURL, body);
  }

  //getSuggestedReleases
  getSuggestedReleasesURL = this.apiURL + AdminConstant.release.getSuggestedReleases;
  getSuggestedReleases = (body: any): Observable<any> => {
    return this.apiService.get(this.getSuggestedReleasesURL + body);
  }
  //GetDBAFiles
  GetDBAFilesURL = this.apiURL + AdminConstant.vacuum.GetDBAFiles;
  GetDBAFiles = (body: any): Observable<any> => {
    return this.apiService.get(this.GetDBAFilesURL + body);
  }
  GetResourcesURL = this.apiURL + AdminConstant.resourcemanagement.GetResources;
  GetResources = (body: any): Observable<any> => {
    return this.apiService.post(this.GetResourcesURL, body);
  }
  UpdateShutdownTagURL = this.apiURL + AdminConstant.resourcemanagement.UpdateShutdownTag;
  UpdateShutdownTag = (body: any): Observable<any> => {
    return this.apiService.post(this.UpdateShutdownTagURL, body);
  }
  StartStopResourceURL = this.apiURL + AdminConstant.resourcemanagement.StartStopResource;
  StartStopResource = (body: any): Observable<any> => {
    return this.apiService.post(this.StartStopResourceURL, body);
  }

  AutoVarResourceURL = this.apiURL + AdminConstant.resourcemanagement.GetAutomationVar;
  AutoVarResource = (): Observable<any> => {
    return this.apiService.get(this.AutoVarResourceURL);
  }

  UpdateAutoVarResourceURL = this.apiURL + AdminConstant.resourcemanagement.UpdateAutomationVar;
  UpdateAutoVarResource = (body: any): Observable<any> => {
    return this.apiService.post(this.UpdateAutoVarResourceURL, body);
  }
  //GetReleaseByProjectTypeId
  GetReleaseByProjectTypeIdURL = this.apiURL + AdminConstant.release.GetReleaseByProjectTypeId;
  GetReleaseByProjectTypeId = (body: any): Observable<any> => {
    return this.apiService.get(this.GetReleaseByProjectTypeIdURL + body.projecttype_id);
  }
  //Get_task_componenttypeData
  Get_task_componenttypeDataURL = this.apiURL + AdminConstant.release.Get_task_componenttypeData;
  Get_task_componenttypeData = (body: any): Observable<any> => {
    return this.apiService.get(this.Get_task_componenttypeDataURL + body.releaseid);
  }
  //Get_task_Data
  Get_task_DataURL = this.apiURL + AdminConstant.release.Get_task_Data;
  Get_task_Data = (body: any): Observable<any> => {
    return this.apiService.get(this.Get_task_DataURL + body.releaseid);
  }

  //Get_release_data 
  Get_release_dataURL = this.apiURL + AdminConstant.release.Get_release_data;
  Get_release_data = (body: any): Observable<any> => {
    return this.apiService.get(this.Get_release_dataURL + body);
  }

  //Get_task_status_by_owner 
  Get_task_status_by_ownerURL = this.apiURL + AdminConstant.release.Get_task_status_by_owner;
  Get_task_status_by_owner = (body: any): Observable<any> => {
    return this.apiService.post(this.Get_task_status_by_ownerURL, body);
  }
  //MultipleAccessForProject
  MultipleAccessForProjectURL = this.apiURL + AdminConstant.userRoles.MultipleAccessForProject;
  MultipleAccessForProject = (body: any): Observable<any> => {
    return this.apiService.post(this.MultipleAccessForProjectURL, body);
  }
  GetFoldersURL = this.apiURL + AdminConstant.vacuum.GetFolders
  GetFolders = (body: any): Observable<any> => {
    return this.apiService.get(this.GetFoldersURL + body)
  }
  //UpdateTask
  UpdateTaskURL = this.apiURL + AdminConstant.release.UpdateTask;
  UpdateTask = (body: any): Observable<any> => {
    return this.apiService.post(this.UpdateTaskURL, body);
  }
  UpdateReleaseURL = this.apiURL + AdminConstant.release.UpdateRelease;
  UpdateRelease = (body: any): Observable<any> => {
    return this.apiService.post(this.UpdateReleaseURL, body);
  }

  //GetReleaseByProjectId
  GetReleaseByProjectIdURL = this.apiURL + AdminConstant.release.GetReleaseByProjectId;
  GetReleaseByProjectId = (projectId: any): Observable<any> => {
    return this.apiService.get(this.GetReleaseByProjectIdURL + projectId);
  }

  GetWorkloadDetailsURL = this.apiURL + AdminConstant.leadership.GetWorkloadDetails;
  GetWorkloadDetails = (projectId: number | null = null): Observable<any> => {
    const query = projectId === null ? '' : `?projectId=${projectId}`;
    return this.apiService.get(this.GetWorkloadDetailsURL + query);
  }

  ExecuteRequestSummaryInUpNamespacesURL = this.apiURL + AdminConstant.leadership.ExecuteRequestSummaryInUpNamespaces;
  ExecuteRequestSummaryInUpNamespaces = (): Observable<any> => {
    return this.apiService.post(this.ExecuteRequestSummaryInUpNamespacesURL, {});
  }

  UpsertWorkloadByNameURL = this.apiURL + AdminConstant.leadership.UpsertWorkloadByName;
  UpsertWorkloadByName = (body: any): Observable<any> => {
    return this.apiService.post(this.UpsertWorkloadByNameURL, body);
  }

  UpsertWorkloadProjectMapURL = this.apiURL + AdminConstant.leadership.UpsertWorkloadProjectMap;
  UpsertWorkloadProjectMap = (body: any): Observable<any> => {
    return this.apiService.post(this.UpsertWorkloadProjectMapURL, body);
  }

  UpsertWorkloadProjectStatusURL = this.apiURL + AdminConstant.leadership.UpsertWorkloadProjectStatus;
  UpsertWorkloadProjectStatus = (body: any): Observable<any> => {
    return this.apiService.post(this.UpsertWorkloadProjectStatusURL, body);
  }

  UpsertWorkloadReleaseMapURL = this.apiURL + AdminConstant.leadership.UpsertWorkloadReleaseMap;
  UpsertWorkloadReleaseMap = (body: any): Observable<any> => {
    return this.apiService.post(this.UpsertWorkloadReleaseMapURL, body);
  }

  /*---- Image Cleanup Mapping Screen ----*/

  // Get kubectl cron deploy images
  getCronDeployImagesURL = this.apiURL + AdminConstant.imageManagement.getCronDeployImages;
  getCronDeployImages = (body: any): Observable<any> => {
    return this.apiService.post(this.getCronDeployImagesURL, body);
  }

  // Get Azure ACR images
  getImageOfRepoURL = this.apiURL + AdminConstant.imageManagement.getArcImages;
  getImageOfRepo = (body: any): Observable<any> => {
    return this.apiService.post(this.getImageOfRepoURL, body);
  }

  // Delete images from repo
  deleteImagesOfRepoURL = this.apiURL + AdminConstant.imageManagement.deleteImagesOfRepo;
  deleteImagesOfRepo = (body: any): Observable<any> => {
    return this.apiService.post(this.deleteImagesOfRepoURL, body);
  }
  UploadExtraFilesURL = this.apiURL + AdminConstant.monitoring.UploadExtraFiles
  UploadAutomationFiles = (body: any): Observable<any> => {
    return this.apiService.post(this.UploadExtraFilesURL, body);
  };

  //GetTryNowFilesFromDir
  GetTryNowFilesFromDirURL = this.apiURL + AdminConstant.monitoring.GetTryNowFilesFromDir;
  GetTryNowFilesFromDir = (body: any): Observable<any> => {
    return this.apiService.get(this.GetTryNowFilesFromDirURL + body)
  }
}

